module.exports = __webpack_public_path__ + "static/media/07.9b35947d.jpg";